import { render } from "./UserCard.vue?vue&type=template&id=0ce62faa&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=0ce62faa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce62faa"],['__file',"src/components/UserCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ce62faa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ce62faa', __exports__)) {
    api.reload('0ce62faa', __exports__)
  }
  
  module.hot.accept("./UserCard.vue?vue&type=template&id=0ce62faa&scoped=true", () => {
    api.rerender('0ce62faa', render)
  })

}


export default __exports__